import type { DatabaseShardManifestEntry } from '@blocksuite/affine-model';
import { type Doc as YDoc, Map as YMap } from 'yjs';

const FILE_INDEX_SHARD_REGISTRY_KEY_PREFIX =
  'streamlain:file-index-shard-registry:';

export function getFileIndexShardRegistry(
  doc: YDoc,
  databaseId: string
): YMap<DatabaseShardManifestEntry> {
  return doc.getMap<DatabaseShardManifestEntry>(
    `${FILE_INDEX_SHARD_REGISTRY_KEY_PREFIX}${databaseId}`
  );
}

export function getFileIndexWriterShardPrefix(doc: YDoc): string {
  return `writer-${doc.clientID.toString(36)}-`;
}

export function nextFileIndexWriterShardId(
  doc: YDoc,
  _entries: readonly DatabaseShardManifestEntry[]
): string {
  const prefix = getFileIndexWriterShardPrefix(doc);
  return `${prefix}${globalThis.crypto.randomUUID()}`;
}

export function sortFileIndexShardEntries(
  entries: Iterable<DatabaseShardManifestEntry>
): DatabaseShardManifestEntry[] {
  return Array.from(entries).sort((left, right) =>
    left.shardId.localeCompare(right.shardId)
  );
}

export function projectFileIndexShardEntries(
  registryEntries: Iterable<DatabaseShardManifestEntry>,
  updatedEntries: readonly DatabaseShardManifestEntry[]
): DatabaseShardManifestEntry[] {
  const entries = new Map(
    Array.from(registryEntries, entry => [entry.shardId, entry])
  );
  for (const entry of updatedEntries) entries.set(entry.shardId, entry);
  return sortFileIndexShardEntries(entries.values());
}

export function selectFileIndexWriterShard(
  entries: readonly DatabaseShardManifestEntry[],
  writerPrefix: string,
  preferredShardId: string | undefined,
  targetBytes: number
): DatabaseShardManifestEntry | undefined {
  const preferred = preferredShardId
    ? entries.find(entry => entry.shardId === preferredShardId)
    : undefined;
  return (
    preferred ??
    entries.find(
      entry =>
        entry.shardId.startsWith(writerPrefix) &&
        entry.encodedBytes < targetBytes
    )
  );
}
